<template>
  <div class="pagina ativa" id="paginaMetas">
    <div class="pagina-titulo">Metas</div>
    <div style="background:white;padding:15px 20px;border-radius:10px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;display:flex;gap:15px;align-items:flex-end;flex-wrap:wrap;">
      <div>
        <label>Mes</label>
        <select v-model="filtroMes" @change="carregar" style="width:150px;">
          <option v-for="m in meses" :key="m.v" :value="m.v">{{ m.l }}</option>
        </select>
      </div>
      <div>
        <label>Ano</label>
        <select v-model="filtroAno" @change="carregar" style="width:120px;">
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
        </select>
      </div>
      <div>
        <label>Vendedores</label>
        <select v-model="filtroStatus" style="width:140px;">
          <option value="ativo">Ativos</option>
          <option value="inativo">Inativos</option>
          <option value="">Todos</option>
        </select>
      </div>
    </div>

    <div v-if="ehAdmin" style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;">
      <div style="font-weight:bold;color:#702e46;font-size:16px;margin-bottom:15px;">Meta Geral da Empresa</div>
      <div style="display:flex;gap:15px;align-items:flex-end;margin-bottom:20px;">
        <div>
          <label>Valor (R$)</label>
          <input type="text" v-model="metaGeralValor" placeholder="Ex: 500.000,00" @input="mascarar('metaGeralValor')" style="width:200px;" />
        </div>
        <button @click="salvarMetaGeral" style="margin-top:0;padding:10px 20px;">Salvar</button>
      </div>
      <div v-if="mgv">
        <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:15px;margin-bottom:15px;">
          <div class="card"><div class="card-label">Realizado</div><div class="card-valor" style="color:#4a5c2f;">{{ fmtBRL(tG) }}</div></div>
          <div class="card"><div class="card-label">Meta da Empresa</div><div class="card-valor">{{ fmtBRL(mgv) }}</div></div>
          <div class="card"><div class="card-label">Falta</div><div class="card-valor" :style="{ color: cG }">{{ fmtBRL(fG) }}</div></div>
        </div>
        <div style="background:#eee;border-radius:10px;height:20px;overflow:hidden;">
          <div :style="{ background: cG, height: '100%', width: pG + '%', borderRadius: '10px', transition: 'width 0.5s', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
            <span style="color:white;font-size:12px;font-weight:bold;">{{ pG.toFixed(1) }}%</span>
          </div>
        </div>
      </div>
    </div>

    <div style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
      <div v-if="ehAdmin" style="display:flex;gap:15px;align-items:flex-end;margin-bottom:20px;flex-wrap:wrap;border-bottom:1px solid #eee;padding-bottom:15px;">
        <div>
          <label>Meta Individual por Vendedor (R$)</label>
          <input type="text" v-model="metaVendedorValor" placeholder="Ex: 100.000,00" @input="mascarar('metaVendedorValor')" style="width:200px;" />
        </div>
        <button @click="salvarMetaVendedor" style="margin-top:0;padding:10px 20px;">Salvar p/ Todos</button>
      </div>
      <div v-else style="display:flex;gap:15px;align-items:flex-end;margin-bottom:20px;flex-wrap:wrap;border-bottom:1px solid #eee;padding-bottom:15px;">
        <div>
          <label>Minha Meta Pessoal (R$)</label>
          <input type="text" v-model="metaPessoalValor" placeholder="Ex: 150.000,00" @input="mascarar('metaPessoalValor')" style="width:200px;" />
        </div>
        <button @click="salvarMetaPessoal" style="margin-top:0;padding:10px 20px;">Salvar Minha Meta</button>
      </div>

      <p v-if="carregando" style="color:#888;text-align:center;padding:20px;">Carregando...</p>
      <template v-else>
        <div v-if="usuariosFiltrados.length === 0" style="color:#aaa;text-align:center;">Nenhum vendedor encontrado.</div>
        <div v-for="u in usuariosFiltrados" :key="u.nome" style="border:1px solid #eee;border-radius:10px;padding:15px;margin-bottom:15px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
            <span style="font-weight:bold;color:#4a5c2f;">{{ u.nome }}</span>
          </div>
          <div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-bottom:15px;">
            <div class="card" style="padding:10px;"><div class="card-label">Realizado</div><div class="card-valor" style="font-size:16px;color:#4a5c2f;">{{ fmtBRL(realizado(u.nome)) }}</div></div>
            <div class="card" style="padding:10px;"><div class="card-label">Meta Individual</div><div class="card-valor" style="font-size:16px;">{{ fmtBRL(metaIndividual) }}</div><div style="font-size:10px;color:#666;margin-top:5px;">Atingido: {{ pct(realizado(u.nome), metaIndividual) }}%</div></div>
            <div class="card" style="padding:10px;"><div class="card-label">Meta Pessoal</div><div class="card-valor" style="font-size:16px;color:#3498db;">{{ fmtBRL(metaPessoal(u.nome)) }}</div><div style="font-size:10px;color:#666;margin-top:5px;">Atingido: {{ pct(realizado(u.nome), metaPessoal(u.nome)) }}%</div></div>
            <div class="card" style="padding:10px;"><div class="card-label">Falta</div><div class="card-valor" style="font-size:16px;" :style="{ color: corAlvo(u.nome) }">{{ fmtBRL(falta(u.nome)) }}</div></div>
          </div>
          <div style="background:#eee;border-radius:10px;height:12px;overflow:hidden;">
            <div :style="{ background: corAlvo(u.nome), height: '100%', width: pctAlvo(u.nome) + '%', borderRadius: '10px', transition: 'width 0.5s' }"></div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, getSession } from '../api'

export default {
  name: 'PaginaMetas',
  data() {
    const hoje = new Date()
    return {
      meses: [
        { v: '01', l: 'Jan' }, { v: '02', l: 'Fev' }, { v: '03', l: 'Mar' }, { v: '04', l: 'Abr' },
        { v: '05', l: 'Mai' }, { v: '06', l: 'Jun' }, { v: '07', l: 'Jul' }, { v: '08', l: 'Ago' },
        { v: '09', l: 'Set' }, { v: '10', l: 'Out' }, { v: '11', l: 'Nov' }, { v: '12', l: 'Dez' }
      ],
      filtroMes: String(hoje.getMonth() + 1).padStart(2, '0'),
      filtroAno: String(hoje.getFullYear()),
      filtroStatus: 'ativo',
      metas: [],
      usuarios: [],
      vendas: [],
      metaGeralValor: '',
      metaVendedorValor: '',
      metaPessoalValor: '',
      carregando: true
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    nomeUsuario() { return getSession().nome },
    vendasDoMes() {
      const chave = this.filtroAno + '-' + this.filtroMes
      return this.vendas.filter(v => (v.dataVenda || '').substring(0, 7) === chave)
    },
    tG() {
      return this.vendasDoMes.reduce((s, v) => s + (v.valor || 0), 0)
    },
    metaGeral() {
      return this.metas.slice().reverse().find(m => parseInt(m.mes) === parseInt(this.filtroMes) && parseInt(m.ano) === parseInt(this.filtroAno) && m.tipo === 'geral')
    },
    mgv() { return this.metaGeral ? parseFloat(this.metaGeral.meta) : 0 },
    pG() { return this.mgv > 0 ? Math.min((this.tG / this.mgv) * 100, 100) : 0 },
    fG() { return Math.max(this.mgv - this.tG, 0) },
    cG() { return this.pG >= 100 ? '#27ae60' : this.pG >= 70 ? '#f39c12' : '#e74c3c' },
    vendasPorVendedor() {
      const vds = {}
      this.vendasDoMes.forEach(v => { vds[v.vendedor] = (vds[v.vendedor] || 0) + (v.valor || 0) })
      return vds
    },
    metaIndividual() {
      const m = this.metas.slice().reverse().find(m => parseInt(m.mes) === parseInt(this.filtroMes) && parseInt(m.ano) === parseInt(this.filtroAno) && m.tipo === 'vendedor' && (m.vendedor || '').trim().toUpperCase() === 'TODOS')
      return m ? parseFloat(m.meta) : 0
    },
    usuariosFiltrados() {
      let d = this.usuarios.filter(u => {
        if (!this.filtroStatus) return true
        if (this.filtroStatus === 'ativo') return u.ativo
        if (this.filtroStatus === 'inativo') return !u.ativo
        return true
      })
      if (!this.ehAdmin) d = d.filter(u => u.nome === this.nomeUsuario)
      return d
    }
  },
  created() {
    this.carregar()
    if (this.ehAdmin) {
      const vs = this.mgv.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      if (this.mgv) this.metaGeralValor = 'R$ ' + vs
    }
  },
  methods: {
    fmtBRL(v) {
      return 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    pct(realizado, meta) {
      return meta > 0 ? (realizado / meta * 100).toFixed(1) : 0
    },
    realizado(nome) { return this.vendasPorVendedor[nome] || 0 },
    metaPessoal(nome) {
      const m = this.metas.slice().reverse().find(m => parseInt(m.mes) === parseInt(this.filtroMes) && parseInt(m.ano) === parseInt(this.filtroAno) && m.tipo === 'pessoal' && (m.vendedor || '').trim().toLowerCase() === nome.trim().toLowerCase())
      return m ? parseFloat(m.meta) : 0
    },
    metaAlvo(nome) {
      const mp = this.metaPessoal(nome)
      return mp > 0 ? mp : this.metaIndividual
    },
    falta(nome) { return Math.max(this.metaAlvo(nome) - this.realizado(nome), 0) },
    pctAlvo(nome) {
      const alvo = this.metaAlvo(nome)
      return alvo > 0 ? Math.min((this.realizado(nome) / alvo) * 100, 100) : 0
    },
    corAlvo(nome) {
      const p = this.pctAlvo(nome)
      return p >= 100 ? '#27ae60' : p >= 70 ? '#f39c12' : '#e74c3c'
    },
    mascarar(campo) {
      let v = this[campo].replace(/\D/g, '')
      v = (parseInt(v || '0') / 100).toFixed(2) + ''
      v = v.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      this[campo] = 'R$ ' + v
    },
    valorNumerico(campo) {
      return parseFloat((this[campo] || '').replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) || 0
    },
    async carregar() {
      this.carregando = true
      const [rm, ru, rv] = await Promise.all([
        apiGet('metas/listar'),
        apiGet('usuarios/listar'),
        apiGet('vendas/com-calculo')
      ])
      if (rm.sucesso) this.metas = rm.metas
      if (ru.sucesso) this.usuarios = ru.usuarios
      if (rv.sucesso) this.vendas = rv.vendas
      this.carregando = false
    },
    async salvarMetaGeral() {
      const v = this.valorNumerico('metaGeralValor')
      await apiPost('metas/salvar', { mes: parseInt(this.filtroMes, 10), ano: parseInt(this.filtroAno, 10), tipo: 'geral', vendedor: 'GERAL', meta: v })
      this.metaGeralValor = ''
      this.carregar()
    },
    async salvarMetaVendedor() {
      const v = this.valorNumerico('metaVendedorValor')
      if (!v) return
      await apiPost('metas/salvar', { mes: parseInt(this.filtroMes, 10), ano: parseInt(this.filtroAno, 10), tipo: 'vendedor', vendedor: 'TODOS', meta: v })
      this.metaVendedorValor = ''
      this.carregar()
    },
    async salvarMetaPessoal() {
      const v = this.valorNumerico('metaPessoalValor')
      if (!v) return
      await apiPost('metas/salvar', { mes: parseInt(this.filtroMes, 10), ano: parseInt(this.filtroAno, 10), tipo: 'pessoal', vendedor: this.nomeUsuario.trim(), meta: v })
      this.metaPessoalValor = ''
      this.carregar()
    }
  }
}
</script>
